/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LogoSmallIcon, ZoomIcon } from 'shared/components/Icons';
import { getUserFollowers } from 'graphql/user/queries';
import { useAlert } from 'react-alert';
import { getError } from 'utils/appHelpers';
import { API, graphqlOperation } from 'aws-amplify';
import { onToggleFollows } from 'app/routes/Dashboard/actions/user';
import Button from 'shared/components/Button';
import Input from 'shared/components/Input';
import TabsNavigation from 'shared/components/layout/TabsNavigation';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import AvatarImg from 'shared/components/AvatarImg';

const ProfileFollowList = ({ history, match }) => {
  const { t } = useTranslation();
  const alert = useAlert();
  const activeList = match.params?.state;
  const account = useSelector(state => state.account);
  const follows = useSelector(state => state.follows);
  const [fetching, setFetching] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState({
    followers: null,
    following: null,
  });

  const links = [
    {
      name: 'text_followers',
      path: '/profile/list/followers',
      state: 'followers',
      count: Object.keys(follows.followers).length,
    },
    {
      name: 'text_following',
      path: '/profile/list/following',
      state: 'following',
      count: Object.keys(follows.following).length,
    },
  ];

  const onChangeTab = item => {
    history.replace(item.path);
  };

  const onFormChange = ({ target }) => {
    setSearch(target.value);
  };

  const getFollowers = async () => {
    try {
      setFetching(true);
      const body = { id: account.id };
      const res = await API.graphql(graphqlOperation(getUserFollowers, body));
      const result = res.data.getUser.followers.items;
      setData({ ...data, followers: result });
    } catch (err) {
      alert.error(getError(err));
    } finally {
      setFetching(false);
    }
  };

  const getFollowings = async () => {
    try {
      setFetching(true);
      const body = { id: account.id };
      const res = await API.graphql(graphqlOperation(getUserFollowers, body));
      const result = res.data.getUser.followees.items;
      setData({ ...data, following: result });
    } catch (err) {
      alert.error(getError(err));
    } finally {
      setFetching(false);
    }
  };

  const onHandleFollowToggle = async user => {
    try {
      onToggleFollows(user);
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const checkAndGetItems = () => {
    if (!data[activeList]) {
      activeList === 'followers' ? getFollowers() : getFollowings();
    }
  };

  useEffect(() => {
    checkAndGetItems();
  }, [activeList]);

  const users = data[activeList]?.filter(i => i.email.includes(search) || i.name.includes(search));

  return (
    <div>
      <div className='col-12 col-md-6 p-0 m-auto pb-10'>
        <h1 className='mb-8 mb-md-15'>{t('title_profile')}</h1>
        <TabsNavigation className='mb-15' items={links} activeItem={activeList} onItemClick={onChangeTab} />
        <div className='search-block d-flex align-items-center border rounded-6 mb-7'>
          <Button type='submit' className='btn-sm svg-gray px-5 py-5 m-2'>
            <ZoomIcon />
          </Button>
          <Input
            type='text'
            name='search'
            onChange={onFormChange}
            value={search}
            placeholder={t('ph_search_follow')}
            className='mb-0 w-100'
            inputClassName='border-0 pl-0'
          />
        </div>
        <div>
          {fetching && <SkeletonLoader type='list-items' count={5} />}
          {!fetching &&
            users?.map(user => {
              const userFollowers = user.followers.items.length;
              const userFollowing = follows.following[user.id];
              return (
                <div
                  key={user.id}
                  className='d-flex align-items-center py-6 py-md-8 border-bottom w-100 justify-content-between'
                >
                  <div
                    className='d-flex align-items-center'
                    tabIndex={-1}
                    role='button'
                    onClick={() => history.push(`/user/${user.id}`)}
                  >
                    <div className='user-avatar mr-10 text-center rounded-100p'>
                      <button className='btn p-0 bg-none d-flex align-items-center justify-content-center'>
                        <LogoSmallIcon width={20} height={20} />
                      </button>
                      <AvatarImg size='md' width='60px' height='60px' picture={user.picture} name={user.name} />
                    </div>
                    <div>
                      <p className='fw-500 mb-3'>{user.name}</p>
                      <p className='mb-0 text-gray-dark fw-300 text-lowercase'>
                        {userFollowers} {t('count_followers', { count: userFollowers })}
                      </p>
                    </div>
                  </div>
                  <Button
                    className='btn-sm btn-outline-dark py-4 px-10 fw-500'
                    onClick={onHandleFollowToggle.bind(null, user)}
                  >
                    {userFollowing ? t('btn_unfollow') : t('btn_follow')}
                  </Button>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ProfileFollowList;
